import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { base_url } from "../utils/baseUrl";
import "./style.css";
import { useNavigate } from "react-router-dom";


// Validation schema
const schema = yup.object().shape({
  facebook: yup.string().url("Invalid URL").optional(),
  instagram: yup.string().url("Invalid URL").optional(),
  twitter: yup.string().url("Invalid URL").optional(),
  linkedin: yup.string().url("Invalid URL").optional(),
  youtube: yup.string().url("Invalid URL").optional(),
});

const AddSocialMediaLinks = () => {
  const [socialLinks, setSocialLinks] = useState(null);
  const [editMode, setEditMode] = useState({});
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  
    useEffect(() => {
      const valid = localStorage.getItem("valid");
      if (valid) {
        setIsValid(true);
      } else {
        navigate("/"); // Redirect to login page if not valid
      }
    }, [navigate]);


  // Fetch existing social links
  useEffect(() => {
    axios
      .get(`${base_url}/api/socials/getSocialLinks`)
      .then((res) => {
        if (res.data.length === 0 || Object.values(res.data[0]).every((link) => !link)) {
          setSocialLinks(null);
        } else {
          setSocialLinks(res.data[0]);
        }
      })
      .catch(() => {
        toast.error("Failed to fetch social media links. Try again!");
      });
  }, []);

  // Formik setup
  const formik = useFormik({
    initialValues: {
      facebook: "",
      instagram: "",
      twitter: "",
      linkedin: "",
      youtube: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      try {
        await axios.post(`${base_url}/api/socials/insertSocialLinks`, values);
        toast.success("Social Media Links Saved Successfully!");
        setSocialLinks(values);
      } catch (error) {
        toast.error("Failed to save social media links. Try again!");
      }
    },
  });

  // Handle individual updates
  const handleUpdate = async (platform) => {
    const updatedLink = formik.values[platform];
    try {
      console.log(platform+" "+updatedLink)
      await axios.post(`${base_url}/api/socials/updateSocialLink`, {
        platform,
        link: updatedLink,
      });
      toast.success(`${platform.charAt(0).toUpperCase() + platform.slice(1)} updated successfully!`);
      setSocialLinks((prev) => ({ ...prev, [platform]: updatedLink }));
      setEditMode((prev) => ({ ...prev, [platform]: false })); // Exit edit mode for the platform
    } catch (error) {
      toast.error(`Failed to update ${platform}. Try again!`);
    }
  };

  // Toggle edit mode
  const toggleEditMode = (platform) => {
    setEditMode((prev) => ({ ...prev, [platform]: !prev[platform] }));
    formik.setFieldValue(platform, socialLinks?.[platform] || ""); // Set initial value
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Social Media Links</h2>
      {!socialLinks ? (
        // Render form for new links
        <form onSubmit={formik.handleSubmit} className="form-container">
          {Object.keys(formik.initialValues).map((platform) => (
            <div className="mb-4" key={platform}>
              <label htmlFor={platform} className="form-label">
                {platform.charAt(0).toUpperCase() + platform.slice(1)}:
              </label>
              <input
                type="url"
                id={platform}
                name={platform}
                placeholder={`Enter ${platform} URL`}
                value={formik.values[platform]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`form-control ${
                  formik.touched[platform] && formik.errors[platform] ? "is-invalid" : ""
                }`}
              />
              {formik.touched[platform] && formik.errors[platform] && (
                <div className="invalid-feedback">{formik.errors[platform]}</div>
              )}
            </div>
          ))}
          <button type="submit" className="btn btn-success w-100">
            Submit
          </button>
        </form>
      ) : (
        // Render existing links with edit functionality
        <form className="form-container">
          {Object.keys(socialLinks).map((platform) => (
            <div className="mb-4" key={platform}>
              <label htmlFor={platform} className="form-label">
                {platform.charAt(0).toUpperCase() + platform.slice(1)}:
              </label>
              {!editMode[platform] ? (
                <div className="d-flex align-items-center">
                  <a href={socialLinks[platform]} target="_blank" rel="noopener noreferrer">
                    {socialLinks[platform] || "No Link"}
                  </a>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary ms-3"
                    onClick={() => toggleEditMode(platform)}
                  >
                    Edit
                  </button>
                </div>
              ) : (
                <div className="d-flex flex-column">
                  <input
                    type="url"
                    id={platform}
                    name={platform}
                    placeholder={`Enter ${platform} URL`}
                    value={formik.values[platform]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`form-control ${
                      formik.touched[platform] && formik.errors[platform] ? "is-invalid" : ""
                    }`}
                  />
                  {formik.touched[platform] && formik.errors[platform] && (
                    <div className="invalid-feedback">{formik.errors[platform]}</div>
                  )}
                  <div className="d-flex mt-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-success me-2"
                      onClick={() => handleUpdate(platform)}
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm "
                      onClick={() => toggleEditMode(platform)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </form>
      )}
    </div>
  );
};

export default AddSocialMediaLinks;
